// 任务规划
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Tabs, Table, App, Card, TimePicker, Select, Button, Switch, theme, Dropdown } from 'antd';
import { PlusOutlined, MinusCircleOutlined, DownOutlined } from '@ant-design/icons';
import { GetTaskList, SaveTask, DelTask, getAirport } from '@/server/task'
import dayjs from 'dayjs';
import './index.css'
const { RangePicker } = TimePicker;//时间段选择框

function TaskPlan() {
  const {
    token: { colorTextTertiary, colorTextQuaternary },
  } = theme.useToken(); //获取主题颜色

  const limitsAuthority = useRef()//权限

  const { message } = App.useApp();
  const token = localStorage.getItem('dock_token');
  const [data, setData] = useState([]);//数据

  const [table_data, setTableData] = useState([]);//表格数据

  const [loading, setLoading] = useState(false);//加载中···

  const [choose_tab, setChooseTab] = useState(0);//日期改变

  const [dictionaryList, setDictionaryList] = useState({//字典集
    airline: [],
    taskType: [],
  })

  const items = [
    { key: 0, label: '周一' },
    { key: 1, label: '周二' },
    { key: 2, label: '周三' },
    { key: 3, label: '周四' },
    { key: 4, label: '周五' },
    { key: 5, label: '周六' },
    { key: 6, label: '周日' },
  ];//tabs数据

  const [routesObj, setRoutesObj] = useState({});//航线数据

  //表格头
  const columns = [
    {
      title: '选择时间',
      render: (text, record) => {
        return (
          <div>
            {/* <RangePicker
              style={{ textAlign: 'center' }}
              // onChange={onChange}
              value={[dayjs(record.starttime, 'HH:mm'), dayjs(record.endtime, 'HH:mm')]}
              allowClear={false}
              format={'HH:mm'}
              bordered={false}
              placeholder={['开始时间', '结束时间']}
              onChange={(e, value) => {
                let obj = record
                obj.starttime = value[0]
                obj.endtime = value[1]
                setTableValue(record.idx, 'time', value, obj);
              }}
            /> */}

            {`${record.starttime}  ~ ${record.endtime}`}
          </div>
        )
      }
    },
    // {
    //   title: '时间', dataIndex: 'times',
    // },
    {
      title: '任务类型', dataIndex: 'type',
      render: (text, record) => {
        return (
          <div>
            {
              (limitsAuthority.current?.indexOf(144) > -1)
                ? (
                  <Select className='w200'
                    disabled={record.is_enable}
                    value={text ? text : undefined}
                    options={dictionaryList.taskType}
                    placeholder='任务类型'
                    onChange={(e) => {
                      setTableValue(record.idx, 'type', e);
                    }}
                  />
                )
                : (
                  <div>
                    {
                      text
                        ? (
                          <span>{dictionaryList.taskType?.find((res) => res.value === text)?.label}</span>
                        )
                        : (
                          <span style={{ color: colorTextQuaternary }}>-</span>
                        )
                    }
                  </div>
                )

            }

          </div>
        )
      }
    },
    {
      title: '航线名称', dataIndex: 'RName',
      render: (text, record) => {
        return (
          <div>
            {
              (limitsAuthority.current?.indexOf(144) > -1)
                ? (
                  <Select
                    className='w200'
                    disabled={(record.is_enable || (record.type > 0 && routesObj[record.type]?.length < 2))}
                    value={record.RID ? record.RID : undefined}
                    options={record.type >= 0 ? routesObj[record.type] : []}
                    placeholder='航线名称'
                    onChange={(e) => {
                      setTableValue(record.idx, 'RID', e)
                    }}
                  />
                )
                : (
                  <div>
                    {
                      text
                        ? (
                          <span>{text}</span>
                        )
                        : (
                          <span style={{ color: colorTextQuaternary }}>-</span>
                        )
                    }
                  </div>
                )

            }

          </div>
        )
      },
    },
    {
      title: '执行', align: 'left', render: (text, record, index) => {
        return (
          <Switch
            size="small"
            disabled={!(limitsAuthority.current?.indexOf(144) > -1)}
            checked={record.is_enable}
            onChange={(e) => {
              let obj = { ...record };
              obj.is_enable = e;
              // 点击执行开关  同步执行动画
              if (record.type && record.RID) {
                let tab = table_data
                tab[index].is_enable = e
                setTableData({ ...tab })
              }
              setTableValue(record.idx, 'Id', e, obj);
            }}
          />
        )
      }
    },
  ];

  const [dropdownName, setDropdownName] = useState('');//下拉菜单名称
  const [dropdownValue, setDropdownValue] = useState();//下拉菜单值
  const [dropdownItem, setDropdownItem] = useState([]);//下拉菜单选项 - 机场

  //获取任务规划数据
  const getTaskListFun = async (dockId) => {
    setLoading(true);
    let res = await GetTaskList({
      access_token: token,
      dock_id: dockId
    });
    if (res.ret !== 200) {
      message.warning(res.msg || '服务器开了小差，请重试');
      return;
    }

    let data = res.data;
    // setAirlineDictionary([...data.routes])
    // setTaskTypes(data.type);
    let dic = dictionaryList
    dic.airline = data.routes
    dic.taskType = data.type
    setDictionaryList({ ...dic })



    /**
     * [
     * 任务类型的id:[航线列表信息],
     * ]
     */
    let typeObj = {};//将任务类型和航线分配到一起
    data.type.forEach((ele, index) => {
      typeObj[`${ele.value}`] = []
      data.routes.forEach((res) => {
        if (ele.value === res.type) {
          typeObj[`${ele.value}`].push({ value: res.id, label: res.title });
        }
      })
    });
    setRoutesObj(typeObj);

    // 将数据按照 周1234567分发到每个数组中
    let arr = [[], [], [], [], [], [], []];
    for (let i = 0; i < data.list.length; i++) {
      let val = data.list[i];
      val.idx = arr[Number(val.performDay) - 1].length;
      if (val.starttime && val.endtime) {
        val.times = val.starttime.slice(0, 5) + ` ~ ` + val.endtime.slice(0, 5);
      } else {
        val.times = '';
      }
      arr[Number(val.performDay) - 1].push({ ...val });
    }
    console.log('arr', arr);
    setData([...arr]);
    setTableData(arr[choose_tab]);
    setLoading(false);
  }

  //标签改变执行
  const TabChange = (e) => {
    setChooseTab(e);
    setTableData(data[e]);
  }

  //修改表格数据
  const setTableValue = (idx, name, value, dataList) => {

    let arr = [...table_data];
    let arrs = [...data];
    let obj = { ...arr[idx] };
    obj[name] = value;

    if (name === 'type' && obj.type >= 1) { //任务类型改变
      obj.RID = routesObj[obj.type].length > 0 ? routesObj[obj.type][0].value : null;
    }
    arr[idx] = obj;
    arrs[choose_tab] = [...arr];

    setTableData([...arr]);
    setData([...arrs]);
    if (obj.RID) {
      saveData(dataList || obj);
    }

  }

  //保存数据
  const saveData = async (dataList) => {
    let obj = {
      access_token: token,
      id: dataList.id,
      RID: dataList.RID,
      RName: dictionaryList.airline.find((item) => item.id === dataList.RID)?.title,
      type: dataList.type,
      is_enable: dataList.is_enable ? 1 : 0,
      starttime: dataList.starttime ? dataList.starttime.slice(0, 5) + ":00" : '',
      endtime: dataList.endtime ? dataList.endtime.slice(0, 5) + ":00" : '',
    }
    let res = await SaveTask(obj);
    if (res.ret === 200) {
      message.success('保存成功');
    } else {
      message.warning(res.msg || '服务器开了小差，请重试');
    }
  }

  //下拉选择
  const chooseDropdown = (info) => {
    if (info.value !== dropdownValue) {
      setDropdownValue(info.value);
      setDropdownName(info.name);
      getTaskListFun(info.value);
    }
  }

  //获取机场
  const getAirportFun = async () => {
    setLoading(true);
    let res = await getAirport({
      access_token: token,
    });
    if (res.ret !== 200) {
      message.warning(res.msg || '数据跑丢了~');
      setLoading(false);
      return;
    }
    let arr = res.data.length > 0 ? res.data.map((item) => {
      return {
        name: item.name,
        value: item.id
      }
    }) : [];
    setDropdownItem(arr);
    setDropdownName(arr.length > 0 ? arr[0].name : '');
    setDropdownValue(arr.length > 0 ? arr[0].value : '');
    getTaskListFun(arr.length > 0 ? arr[0].value : '')
  }

  useEffect(() => {
    getAirportFun();
    limitsAuthority.current = JSON.parse(localStorage.getItem('dock_AirportPermissionsArr'));

    //eslint-disable-next-line
  }, [])

  return (
    <Card style={{ border: 0 }} className="mar24" bodyStyle={{ padding: '12px  24px  24px  24px' }} id="taskPlan">
      <Tabs value={choose_tab} items={items} onChange={TabChange} tabBarExtraContent={{
        left: <Dropdown trigger={['click']}
          menu={{
            items: dropdownItem.map((item, idx) => {
              return {
                label: <div onClick={() => { chooseDropdown(item) }}>{item.name}</div>,
                value: item.value,
                key: idx,
              };
            }),
          }}
        >
          <div className='pointer' style={{ display: dropdownItem.length > 0 ? '' : 'none' }}>
            <span className='marR4'>{dropdownName}</span>
            <DownOutlined className='fs10' style={{ color: colorTextTertiary }} />
          </div>
        </Dropdown>
      }} />
      <div>
        <Table columns={columns} dataSource={table_data} pagination={false} loading={loading}
          rowKey='idx'
        >
        </Table>
      </div>
    </Card>
  )
}
export default TaskPlan